const passwordupdate = (state = {}, action) => {
  let localState = state;
  switch (action.type) {
    case 'UPDATE_CLIENT_PASSWORD_SUCCESS':
      localState = {
        status: 'ok',
      };
      return localState;
    case 'UPDATE_CLIENT_PASSWORD_ERROR':
      localState = {
        status: 'error',
        msg: action.data.hash[0],
      };
      return localState;
    default:
      return localState;
  }
};

export default passwordupdate;



// WEBPACK FOOTER //
// ./src/Reducers/passwordupdate.js